// @ts-nocheck
import { apiRequest } from "../../../services/apiService";
import {
  ADD_CONTRACTOR_LINK_FAILURE,
  ADD_CONTRACTOR_LINK_REQUEST,
  ADD_CONTRACTOR_LINK_SUCCESS,
  CLOSE_MANAGE_APPROVALS_MODAL,
  CLOSE_VIEW_DOCUMENT_MODAL,
  DELETE_CONTRACTOR_LINK_FAILURE,
  DELETE_CONTRACTOR_LINK_REQUEST,
  DELETE_CONTRACTOR_LINK_SUCCESS,
  FETCH_ALL_CONTRACTOR_DOCUMENTS_FAILURE,
  FETCH_ALL_CONTRACTOR_DOCUMENTS_REQUEST,
  FETCH_ALL_CONTRACTOR_DOCUMENTS_SUCCESS,
  FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE,
  FETCH_CONTRACTOR_DOCUMENT_URL_REQUEST,
  FETCH_CONTRACTOR_DOCUMENT_URL_SUCCESS,
  FETCH_CONTRACTOR_DOCUMENTS_BY_ID_FAILURE,
  FETCH_CONTRACTOR_DOCUMENTS_BY_ID_REQUEST,
  FETCH_CONTRACTOR_DOCUMENTS_BY_ID_SUCCESS,
  GET_CONTRACTOR_FOR_MANAGE_APPROVALS_FAILURE,
  GET_CONTRACTOR_FOR_MANAGE_APPROVALS_REQUEST,
  GET_CONTRACTOR_FOR_MANAGE_APPROVALS_SUCCESS,
  GET_CONTRACTOR_LINK_FAILURE,
  GET_CONTRACTOR_LINK_REQUEST,
  GET_CONTRACTOR_LINK_SUCCESS,
  OPEN_MANAGE_APPROVALS_MODAL,
  OPEN_VIEW_DOCUMENT_MODAL,
  UPDATE_MANAGE_APPROVAL_DATA,
} from "../../constants/config/contractorLink";
import { alertDialogAciton } from "../auth";

/**
 * get contractor link action
 * http://localhost:8000/api/v5/getContractorTypeLinks
 */
export const getContractorLinkAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_CONTRACTOR_LINK_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getContractorTypeLinks",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: GET_CONTRACTOR_LINK_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_CONTRACTOR_LINK_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to get onboarding links.",
        }),
      );
    }
  };
};

/**
 * add onboarding link action
 * http://localhost:8000/api/v5/addContractorTypeLink
 *
 * {
   "linkData":[{
     "contractorType":"w2",
    "link":"https://dev-app.showphaze.com/contractor-signup"
   },
   {
     "contractorType":"1099",
    "link":"https://dev-app.showphaze.com/contractor-signup"
   },
   {
     "contractorType":"V.C.",
    "link":"https://dev-app.showphaze.com/contractor-signup"
   }
   ]
}
 */
export const addContractorTypeLinkAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CONTRACTOR_LINK_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "addContractorTypeLink",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: ADD_CONTRACTOR_LINK_SUCCESS, payload: response?.data });
      successCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "Links successfully added.",
        }),
      );
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_CONTRACTOR_LINK_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to add onboarding links",
        }),
      );
    }
  };
};

/**
 * delete onboarding link action
 * http://localhost:8000/api/v5/deleteContractorTypeLink?id=697cc67cb877a10b3c5f2fa7
 */
export const deleteContractorLinkAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_CONTRACTOR_LINK_REQUEST,
      payload: payload?.params?.id,
    });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "deleteContractorTypeLink",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: DELETE_CONTRACTOR_LINK_SUCCESS,
        payload: response?.data,
      });
      successCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message:
            response?.data?.message || "Onboarding link deleted successfully",
        }),
      );
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_CONTRACTOR_LINK_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message ||
            "Failed to delete onboarding link",
        }),
      );
    }
  };
};

/**
 * fetch all contractor documents action
 */
export const fetchAllContractorDocuments = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ALL_CONTRACTOR_DOCUMENTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "",
      url: "",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({
        type: FETCH_ALL_CONTRACTOR_DOCUMENTS_SUCCESS,
        payload: response?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ALL_CONTRACTOR_DOCUMENTS_FAILURE });
      failureCallback?.();
    }
  };
};

/**
 * open view document modal
 */
export const openViewDocumentModalAction = ({ payload }) => {
  return { type: OPEN_VIEW_DOCUMENT_MODAL, payload };
};

/**
 * close view document modal
 */
export const closeViewDocumentModalAction = () => {
  return { type: CLOSE_VIEW_DOCUMENT_MODAL };
};

/**
 * fetch contractor document urls action
 * @example
 * api/v4/getAgreementDocuments
 */
export const fetchContractorDocumentUrls = () => {
  return async (dispatch, getState) => {
    if (getState?.()?.contractorLink?.contractorPdfStatus === "loading") return;
    dispatch({ type: FETCH_CONTRACTOR_DOCUMENT_URL_REQUEST });
    try {
      const { response } = await apiRequest({
        method: "GET",
        url: "getAgreementDocuments",
        isToken: true,
      });
      if (response?.status === 200) {
        dispatch({
          type: FETCH_CONTRACTOR_DOCUMENT_URL_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({ type: FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE });
      }
    } catch {
      dispatch({ type: FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE });
    }
  };
};

/**
 * fetch contractor documents by id
 * @example
 *api/v4/getContractorAgreementsById?contractorId=68c996edf34f81ed7a992a8a
 */
export const fetchContractorDocumentsById = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CONTRACTOR_DOCUMENTS_BY_ID_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getContractorAgreementsById",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: FETCH_CONTRACTOR_DOCUMENTS_BY_ID_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (response?.status != 200 || error) {
      dispatch({ type: FETCH_CONTRACTOR_DOCUMENTS_BY_ID_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message || "Failed to get agreements.",
        }),
      );
      failureCallback?.();
    }
  };
};

/**
 * open manage approval modal action
 */
export const openManageApprovalModalAction = ({ payload }) => {
  return { type: OPEN_MANAGE_APPROVALS_MODAL, payload };
};

/**
 * close manage approval modal action
 */
export const closeManageApprovalModalAction = () => {
  return { type: CLOSE_MANAGE_APPROVALS_MODAL };
};

/**
 *  get contractor details for manage approvals
 *
 * v2/getcontractorById/${contractorId}
 */
export const getContractorDetailsForManageApprovalsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_CONTRACTOR_FOR_MANAGE_APPROVALS_REQUEST });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getContractorById/${payload?.contractorId}`,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: GET_CONTRACTOR_FOR_MANAGE_APPROVALS_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_CONTRACTOR_FOR_MANAGE_APPROVALS_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message ||
            "Failed to get contractor's details",
        }),
      );
      failureCallback?.();
    }
  };
};

/**
 * update manage approval data
 * @params {object} payload
 */
export const updateManageApprovalDataAction = ({ payload }) => {
  return { type: UPDATE_MANAGE_APPROVAL_DATA, payload };
};